import { render, staticRenderFns } from "./SendDelegatesEmail.vue?vue&type=template&id=b2c7a8bc"
import script from "./SendDelegatesEmail.vue?vue&type=script&lang=js"
export * from "./SendDelegatesEmail.vue?vue&type=script&lang=js"
import style0 from "./SendDelegatesEmail.vue?vue&type=style&index=0&id=b2c7a8bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports